<div
  class="flex flex-col items-center justify-center h-screen bg-gray-50 dark:bg-gray-900 px-4"
>
  <div class="max-w-md text-center">
    <svg
      class="mx-auto mb-6 w-24 h-24 text-yellow-500"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 9v4m0 4h.01M12 3C7.03 3 3 7.03 3 12s4.03 9 9 9 9-4.03 9-9S16.97 3 12 3z"
      />
    </svg>

    <h1 class="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-2">
      This link has expired
    </h1>
    <p class="text-gray-600 dark:text-gray-400 mb-6">
      The verification or reset link you used is no longer valid. Please request
      a new one to continue.
    </p>

    <div class="flex flex-col sm:flex-row gap-3 justify-center">
      <a
        class="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-300"
        (click)="goToForgotPassword()"
      >
        Request New Link
      </a>
      <a
        class="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium text-blue-700 bg-white border border-blue-600 rounded-lg hover:bg-blue-50 focus:ring-4 focus:ring-blue-200"
        (click)="goHome()"
      >
        Back to Home
      </a>
    </div>
  </div>
</div>
